module.exports = __webpack_public_path__ + "static/img/hanson-lu-Q36BvLGdOAg.4b5fc30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911261/hanson-lu-Q36BvLGdOAg.jpg
// module id = C1aW
// module chunks = 1